import Env from '~/env';
import apiHybris from '~/services/apiHybris';
import { GetUserInformationUseCase } from './GetUserInformationUseCase';
import { useUserInfoStore } from '~/stores/userInfo';
import axios from 'axios';
import {
  GENERIC_ERROR_OK_EMPTY_RESPONSE,
  getFriendlyError,
} from '~/utils/getFriendlyError';

const SignInUseCase = async (
  username: string,
  password: string
): Promise<void> => {
  try {
    const postData = {
      client_id: 'marisa_mobile_app',
      client_secret: 'SQ9*e2Z@',
      grant_type: 'password',
      username: username.toLowerCase(),
      password,
    };

    const { data } = await apiHybris.post<Marisa.RefreshTokenDTO>(
      `https://${Env.API_HOST}/authorizationserver/oauth/token`,
      postData,
      {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      }
    );

    if (!data || !data.access_token) {
      throw new Error(GENERIC_ERROR_OK_EMPTY_RESPONSE);
    }

    await GetUserInformationUseCase(data.access_token);
    await useUserInfoStore.getState().loadContractedServices();
  } catch (error) {
    useUserInfoStore.setState({ user: null });
    if (axios.isAxiosError(error)) {
      if (!error.response || !error.response.data) {
        error.message = GENERIC_ERROR_OK_EMPTY_RESPONSE;
      } else {
        const { error: errorType, error_description } = error.response.data;
        error.message = getFriendlyError(errorType, error_description);
      }
    }
    throw error;
  }
};

export default SignInUseCase;
